import { render } from "./InputAnnotation.vue?vue&type=template&id=5a03f44a&scoped=true"
import script from "./InputAnnotation.vue?vue&type=script&lang=js"
export * from "./InputAnnotation.vue?vue&type=script&lang=js"

import "./InputAnnotation.vue?vue&type=style&index=0&id=5a03f44a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a03f44a"]])

export default __exports__